// Wrapper seguro pra localStorage/sessionStorage — engole exceção e cai no
// comportamento mais seguro (não persiste) em vez de derrubar a árvore React
// inteira com "Algo deu errado".
//
// POR QUE EXISTE: `localStorage` pode lançar `SecurityError`/`DOMException`
// em vários cenários reais (battery saver agressivo, modo privado antigo do
// Safari, quota cheia, MDM corporativo, iframe de terceiro sem storage
// particionado) — qualquer acesso cru nesses casos derruba a página inteira
// sem relação nenhuma com o que o usuário estava fazendo. Bug real já
// corrigido uma vez (27/08/2026) só dentro de `lib/api.ts` — mas o app tinha
// dezenas de outros acessos crus espalhados por 30 arquivos, cada um um ponto
// de falha igual. Ver `[[feedback_...]]`/CLAUDE.md, seção "Bug real corrigido
// — crash ao trocar de página/aba" (06/09/2026).
export function safeGetItem(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}
export function safeSetItem(key: string, value: string): void {
  try { localStorage.setItem(key, value); } catch { /* storage indisponível — segue sem persistir */ }
}
export function safeRemoveItem(key: string): void {
  try { localStorage.removeItem(key); } catch { /* storage indisponível */ }
}

export function safeSessionGetItem(key: string): string | null {
  try { return sessionStorage.getItem(key); } catch { return null; }
}
export function safeSessionSetItem(key: string, value: string): void {
  try { sessionStorage.setItem(key, value); } catch { /* storage indisponível */ }
}
export function safeSessionRemoveItem(key: string): void {
  try { sessionStorage.removeItem(key); } catch { /* storage indisponível */ }
}
